<template lang="html">
  <nav>
    <ul class="link-list">
      <li v-for="item in items" :key="item.id" class="link-list__item">
        <nuxt-link
          v-if="item.targetPage && item.targetPage.url"
          class="link-list__text"
          :to="item.targetPage && item.targetPage.url"
        >
          {{ item.readableName }}
        </nuxt-link>
        <span v-else class="link-list__text">
          {{ item.readableName }}
        </span>
      </li>
    </ul>
  </nav>
</template>

<script>
import VueTypes from "vue-types";

export default {
  props: {
    items: VueTypes.arrayOf(
      VueTypes.shape({
        name: String,
        title: Object,
      })
    ).def([]).loose,
  },
};
</script>

<style lang="scss">
@import "beisheim/scss/colors";
@import "beisheim/scss/scale";
@import "beisheim/scss/font-sizes";

.link-list__item {
  padding: scale(4) 0;

  .router-link-exact-active {
    text-decoration: underline;
  }
}

.link-list__text {
  font-size: font-size(1);

  &:hover,
  &:focus {
    text-decoration: underline;
  }
}
</style>
